import React from 'react';
import { useState, useEffect } from 'react' 
import { Link } from 'react-router-dom';
import { db } from '../../../../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot } from 'firebase/firestore';

const Ionic = ({portfolioData})=> {  
    return (
        <>
            {/* <div className="page-hd clearfix">
                <div className="left-float" style={{marginTop: "0px", marginRight: "20px"}}>
                    <img src="/images/skin1/angular-logo.png" /> 
                </div>
                <div className="left-float" style={{marginTop: "10px"}}>
                    <p><strong>Experience: 4.5 Years</strong></p>
                    <p><strong></strong></p>
                </div>
            </div> */}
            <h1>Ionic <h3>- 2 Years</h3></h1> 
            <ul>
                <li>- Created hybrid mobile applications for Android & iOS.</li>
                <li>- Good understanding of the framework & its out-of-box components.</li>
                <li>- Good experience in customizing the themes.</li>
                <li>- Hands on experience in integrating Cordova plugins.</li>
                <li>- Involved in creating Android artifacts for test & production releases.</li>
            </ul>
             
        </>
    )
}
export default Ionic;